export default {"src":"/_next/static/media/error.92b10c9d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};